<template>
  <div>
    <van-nav-bar v-if="false" style="background:#f5f5f5;padding-top:25px" title="详情" left-arrow @click-left="$router.go(-1)" />
    <van-image
      style="width: 100%"
      :src="require('/static/img/news_detail.png')"
    />
  </div>
</template>

<script>
import { NavBar } from 'vant'
export default {
  components: {
    [NavBar.name]: NavBar
  }
}
</script>

<style lang="scss" scoped>
</style>

